/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { SwapY2XModule__factory } from "./SwapY2XModule__factory";
